export default __webpack_public_path__ + "static/media/Toll-Gates.40a9ec7f.svg";